export const EmailDomains = [
  'amazon.com',
];

export const HOW_MANY_TRACKER = {
  WebsiteAccess_URL_LOCAL: 'https://0s62bmu3aj.execute-api.us-east-1.amazonaws.com/PROD/pixel/tracker?PixelID=806d1a92-a1ad-e955-e540-10aff938b390',
  WebsiteAccess_URL_BETA: 'https://0s62bmu3aj.execute-api.us-east-1.amazonaws.com/PROD/pixel/tracker?PixelID=4783fafd-400e-6ab3-cb4b-8f48fe97e183',
  WebsiteAccess_URL_PROD: 'https://0s62bmu3aj.execute-api.us-east-1.amazonaws.com/PROD/pixel/tracker?PixelID=62930635-58aa-3cbe-62e9-da0d359d05e3'
};

export const Modes = [
  { label: 'Card and Pin', value: 'Card and Pin' },
  { label: 'Card Only', value: 'Card Only' },
  { label: 'Facility Code', value: 'Facility Code' },
  { label: 'Locked', value: 'Locked' },
  { label: 'Pin or Card', value: 'Pin or Card' },
  { label: 'Unlocked', value: 'Unlocked' },
  { label: 'Unknown', value: 'Unknown' },
];

export enum OnguardReaderMaskActionTypes {
  doorForcedOpen = 10,
  doorHeldOpen = 11
}

export const ProdDomain = 'silencio.gso.amazon.dev';

export const URLS = {
  Contact: 'https://w.amazon.com/index.php/SIDE#HContactus',
  FeatureRequest: 'https://tiny.amazon.com/1dwqzl1pa/SilencioV2-FeatureRequest',
  GuardianHub: 'https://guardian.gso.amazon.dev/',
  ReportABug: 'https://t.corp.amazon.com/create/options?ticket_type=Regular+Ticket&severity=FIVE&category=Global+Security+Ops+-+Systems&type=SilencioV2&item=General&building_id=AUS18&group=SIDE+Development+Team&assignee=side-support-primary&asin=&quantity=&isd=&upc=&binding=&vendor_id=&purchase_order_id=&stock_number=&ship_origin=&invoice_number=&physical_location=&tracking_number=&bol_number=&picture_file_imdex_location=&vendor_info_title=',
  UserGuide: 'https://w.amazon.com/bin/view/SIDE/SilencioV2/',
};

export enum UserActionNames {
  AuthenticateUser = "Authenticate User",
  AuthenticateUserError = "Error: Authenticate User",
  CreateUserPreferences = "Create User Preferences",
  CreateUserPreferencesError = "Error: Create User Preferences",
  FetchUserPreferences = "Fetch User Preferences",
  FetchUserPreferencesError = "Error: Fetch User Preferences",
  SelectSite = "Select Site",
  SelectSiteError = "Error: Select Site",
  SetInputMask = "Set Input Mask",
  SetInputMaskError = "Error: Set Input Mask",
  SetReaderDoorHeldMask = "Set Reader Door Held Mask",
  SetReaderDoorHeldMaskError = "Error: Set Reader Door Held Mask",
  SetReaderDoorForcedMask = "Set Reader Door Forced Mask",
  SetReaderDoorForcedMaskError = "Error: Set Reader Door Forced Mask",
  SetReaderMode = "Set Reader Mode",
  SetReaderModeError = "Error: Set Reader Mode",
  UpdateUserPreferences = "Update User Preferences",
};

export const Regions = ['AMER','APAC','EMEA'];

export const Statuses = [
  { label: 'Masked', value: 'Masked' },
  { label: 'Unmasked', value: 'Unmasked' },
];